(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5183],{

/***/ 13208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/[schoolId]",
      function () {
        return __webpack_require__(29287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var features_klass_components_KlassDetail__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53170);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




var KDTDetail = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var schoolId = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return router.query.schoolId;
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(features_klass_components_KlassDetail__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        schoolId: schoolId
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (KDTDetail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,6408,4653,5724,6790,5966,9464,4872,6261,6463,1321,3881,6800,5202,1623,9537,3170,9774,2888,179], function() { return __webpack_exec__(13208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);